// import cal from './cal'
import cal from '../components/fillingBlanks/cal'

export default function answersTrueFalse(recordQuestion, answer_results, form) {
  let student_choices = JSON.parse(JSON.stringify(answer_results.student_choices))
  recordQuestion = JSON.parse(JSON.stringify(recordQuestion))
  form = JSON.parse(JSON.stringify(form))

  // 选择题
  if(form.type == 0) {
    if(!recordQuestion) {
      return false;
    }

    if(recordQuestion.length != form.answers.length) return false

    let aIds = form.answers.map(its => its.choice_id).sort(),
    rIds = recordQuestion.sort()
    for(let i = 0; i < aIds.length; i++) {
      if(aIds[i] != rIds[i]) return false
    }

    return true
  } 
  // 判断题
  else if(form.type == 1) {
    let [answers] = form.answers
    return answers.choice_id == recordQuestion
  }
  // 填空题
  else if(form.type == 2) {
    if(recordQuestion.length != form.answers.length) return false
    for(let i = 0; i < recordQuestion.length; i++) {
      // 数学等式
      if(recordQuestion[i].type == 'arithmetic') {
        if(recordQuestion[i].value == undefined) {
          return false;
        }

        let value = JSON.parse(recordQuestion[i].value || '')
        , gs = form.choices[i].value
        , regex = gs.match(/[a-zA-ZⒶ-Ⓩ]/g)
        , letters = [],
        // 用户填写的答案
        userAnswers = []
        for(let j in value) {
          if(typeof value[j] == 'object') {
            if(value[j].type != undefined) {
              value[j] = value[j].value
            } else {
              letters.push(j)
              // 如果用户未填答案 为空字符串 为其赋值最小负数
              let n = value[j].value.trim() == '' ? Number.MIN_SAFE_INTEGER : value[j].value
              userAnswers.push(Number(n))
              value[j] = 'x'
            }
          }
        }
        regex.filter(letter => {
          gs = gs.replace(letter, value[letter])
        })
        //  gs : (8-2)*10=60
        let dsAnswer = gs.split('='),
        first = null,
        calculates = dsAnswer.filter(its => {
          if(its.indexOf('x') > -1) {
            return its
          } else first = its
        })
        for(let i = 0; i < calculates.length; i++) {
          // 保留10位有效数字 小数: 9, 负数: 9, 负小数: 8
          let retentionLength = 10
          let rightAnswers = String(cal(`${calculates[i]}-(${first})`))
          // 负数
          if(rightAnswers < 0) {
            if(rightAnswers.length > 10) {
              retentionLength = 9
              // 整数, 小数
              let [zs, xs] = String(rightAnswers).split('.'),
              xsLeng = retentionLength - zs.length
              xs = Math.round(('0.' + xs) * (10 ** xsLeng)) / (10 ** xsLeng)
  
              rightAnswers = -(Math.abs(Number(zs)) + Number(xs))
            }
          } else {
            // 正数
            if(rightAnswers.length > 10) {
              retentionLength = 9
              // 整数, 小数
              let [zs, xs] = String(rightAnswers).split('.'),
              xsLeng = retentionLength - zs.length
              xs = Math.round(('0.' + xs) * (10 ** xsLeng)) / (10 ** xsLeng)
              rightAnswers = Number(zs) + Number(xs)
            }
          }
          if(userAnswers[0] == Number(rightAnswers)) {
            // 移除userAnswers对比的元素
            userAnswers.splice(0, 1)
          } else return false
        }
      } else if(recordQuestion[i].type == 'default') {
        if(recordQuestion[i].value != form.answers[i].value) return false
      }
    }

    return true
  } 
  // 算术题（定数）
  else if(form.type == 3) {
    let { studentAnswer } = recordQuestion
    
    if(!studentAnswer) {
      return false;
    }

    for(let i = 0; i < studentAnswer.length; i++) {
      if(studentAnswer[i] != form.answers[i].value) return false
    }

    return true
  } 
  // 热点图
  else if(form.type == 4) {
    if(recordQuestion.length == 0) {
      return false
    }

    let handleR = recordQuestion.map(its => its.choice_id).sort(),
    handleA = form.answers.map(its => its.choice_id).sort()
    if(handleA.length == handleR.length) {
      for(let i = 0; i < handleR.length; i++) {
        if(handleA[i] != handleR[i]) return false
      }
    } else return false

    return true
  } 
  // 文本拖拽（选项）
  else if(form.type == 5) {
    if(student_choices.length == 0) {
      return false
    }

    let handleStudent = {},
    handleAnswers = {}

    student_choices.filter(its => {
      if(its.value != '[]') {
        handleStudent[its.choice_id] = its.value
      }
    })
    form.answers.filter(its => {
      if(its.value != '[]') {
        handleAnswers[its.choice_id] = its.value
      }
    })

    for(let i in handleStudent) {
      let sItem = handleStudent[i],
      aItem = handleAnswers[i] || ''
      if(sItem != aItem) return false 
    }
    return true
  } 
  // 连线题
  else if(form.type == 6) {
    // 学生没答 → 错
    if (!student_choices || student_choices.length === 0) {
      return false;
    }

    // 逐题对比
    for (let i = 0; i < form.answers.length; i++) {
      const answer = form.answers[i];
      const student = student_choices[i];

      // 标准答案（处理 null）
      const correct = String(answer?.value ?? "").trim();

      // 学生答案（处理 null）
      const user = String(student?.value ?? "").trim();

      // 只要一个不对 → 整题错
      if (user !== correct) {
        return false;
      }
    }

    return true;
  } 
  // 图片拖拽
  else if(form.type == 7) {
    let keys = Object.keys(recordQuestion)
    if(keys.length == 0) {
      return false
    }
    for(let i = 0; i < keys.length; i++) {
      let rItem = recordQuestion[keys[i]],
      [aItem] = JSON.parse(form.answers[i].value)

      if(!aItem) continue
      else if(rItem != aItem.value) return false 
    }
    return true
  } 
  // 算术题（变数）
  else if(form.type == 8) {
    localStorage.setItem('record', JSON.stringify(recordQuestion))
    if (!recordQuestion.studentAnswer) {
      return false;
    }
    let {num1, num2, num3, num4} = recordQuestion.numberList,
    { fillIdx } = recordQuestion, studentAnswer = recordQuestion.studentAnswer.join('') * 1

    // 当出现没出现第三列时 将num4 赋值给num3
    if(num3 == undefined) num3 = num4

    if(fillIdx == 1 && studentAnswer == num1) return true
    else if(fillIdx == 2 && studentAnswer == num2) return true
    else if(fillIdx == 3 && studentAnswer == num3) return true
    else if(fillIdx == 4 && studentAnswer == num4) return true
    
    return false
  } 
  // 文本拖拽（分类）
  else if(form.type == 9) {
    let { answers } = form
    if(recordQuestion.length == 0) {
      return false
    }

    for(let i = 0; i < recordQuestion.length; i++) {
      let answersList = answers[i].value.split(',').sort(),
      its = recordQuestion[i].sort()

      if(its.length == answersList.length) {
        for(let j = 0; j < its.length; j++) {
          if(its[j] != answersList[j]) return false
        }
      } else return false
    }

    return true
  } 

  // 矩形填空
  else if(form.type == 10) {
    if(recordQuestion.length != form.answers.length) return false
    for(let i = 0; i < recordQuestion.length; i++) {
      if(recordQuestion[i].value != form.answers[i].value) return false
    }

    return true
  } 
}